import React, { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { getSeoForPath, SITE_NAME, DEFAULT_DESCRIPTION } from "../config/seoRoutes";

/**
 * Updates <title>, meta description, Open Graph, Twitter, robots, and canonical per route.
 */
const Seo = () => {
  const { pathname } = useLocation();
  const seo = useMemo(() => getSeoForPath(pathname), [pathname]);
  const description = seo.description || DEFAULT_DESCRIPTION;
  const fullTitle = `${seo.title} | ${SITE_NAME}`;
  const ogTitle = seo.ogTitle ? `${seo.ogTitle} | ${SITE_NAME}` : fullTitle;
  const ogDescription = seo.ogDescription || description;
  const ogType = seo.ogType || "website";
  const canonical =
    typeof window !== "undefined"
      ? `${window.location.origin}${pathname.split("?")[0]}`
      : "";

  return (
    <Helmet titleTemplate={`%s | ${SITE_NAME}`} defaultTitle={SITE_NAME}>
      <html lang="en" />
      <title>{seo.title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={seo.robots} />
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      {seo.ogImage ? <meta property="og:image" content={seo.ogImage} /> : null}

      <meta
        name="twitter:card"
        content={seo.ogImage ? "summary_large_image" : "summary"}
      />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={ogDescription} />
      {seo.ogImage ? <meta name="twitter:image" content={seo.ogImage} /> : null}
    </Helmet>
  );
};

export default Seo;
